/*
 * Enum for referring to panes/menus in the UI
 */

const panes = {
  PREVIEW: 'PREVIEW',
  BURST: 'BURST',
  SETTINGS: 'SETTINGS',
  NONE: 'NONE',
  FILES: 'FILES'
};

export default panes;
